import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/manual-receipt";

export const Route = createFileRoute("/admin/_manual-receipt/manual-receipts")({
  component: Page,
});
